//@flow

import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import getter from 'dibs-object-getter';

import styles from './HelpInfo.scss';

import type { HelpInfo_viewer as Viewer } from './__generated__/HelpInfo_viewer.graphql';

type Props = {
    viewer: Viewer,
};

export function HelpInfoComponent(props: Props) {
    const tradeRepData = getter(props)
        .at('viewer')
        .at('tradeRep')
        .at(0)
        .at('userDataB')
        .value(0);
    const tradeRepEmail = getter(tradeRepData).value('email');
    const tradeRepFirstName = getter(tradeRepData).value('firstName');
    const tradeRepFullName = getter(tradeRepData).value('displayName');
    const tradeRepPhoneNumber = getter(tradeRepData).value('phoneNumber');

    return (
        <div className={styles.container} data-tn="rewards-help-info-footer">
            <div className={styles.helpMessage}>
                <div>
                    <span className={styles.haveQuestions}>
                        <FormattedMessage
                            id="abt.rewards.HelpInfo.haveQuestions"
                            defaultMessage="Have Questions?"
                        />
                    </span>
                    <span className={styles.weCanHelp}>
                        <FormattedMessage
                            id="abt.rewards.HelpInfo.weCanHelp"
                            defaultMessage="We Can Help"
                        />
                    </span>
                </div>
                <div className={styles.helpMessageSecondary}>
                    <FormattedMessage
                        id="abt.rewards.HelpInfo.reachOut"
                        defaultMessage="Reach out to {tradeRepFirstName}, your trade representative. Learn more about how you can maximize your points."
                        values={{ tradeRepFirstName }}
                    />
                </div>
            </div>
            <div className={styles.repInfo}>
                <div>{tradeRepFullName}</div>
                <div>{tradeRepEmail}</div>
                <div>{tradeRepPhoneNumber}</div>
            </div>
        </div>
    );
}

export const HelpInfo = createFragmentContainer(HelpInfoComponent, {
    viewer: graphql`
        fragment HelpInfo_viewer on Viewer {
            tradeRep: userRelationships(userIds: $userIds, relationshipType: TRADE)
                @include(if: $hasUserId) {
                userDataB {
                    ... on TradeRepData {
                        displayName
                        firstName
                        email
                        phoneNumber(formatType: INTERNATIONAL)
                    }
                }
            }
        }
    `,
});
